import React from "react";
import Slider from "react-slick";
import { Container } from "react-grid-system";
import FrontendAnimation from "../lottie/Frontend/Frontend";
import MongoAnimation from "../lottie/Mongo/Mongo";
import ReactAnimation from "../lottie/React/React"

import "../App.css"
import WebAnimation from "../lottie/Web/Web";
import RestfulAnimation from "../lottie/Restful/Restful";
import ResponsiveAnimation from "../lottie/Responsive/Responsive"

function Service() {
    let sliderSettings = {
        dots: true,
        speed: 500,
        arrows: false,
        infinite: true,
        initialSlide: 0,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                },
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                },
            },
            {
                breakpoint: 993,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    centerMode: true,
                    centerPadding: 50,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: 100,
                },
            },
            {
                breakpoint: 570,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <section className="section section-service section-service-5">
            <div className="display-spacing mb-0">
                <Container>
                    <header className="el-heading el-heading-center">
                        <div className="el-icon">
                            <h2 className="el-icon-title">
                                <span>SERVICE</span>
                            </h2>
                        </div>
                        <h3>Let's See My Services</h3>
                        <div className="divider divider-1-reverse divider-1-1"></div>
                        <div className="divider divider-1-reverse divider-1-2"></div>
                    </header>
                    <Slider className="el-slider el-slider-plr--15 mb-30" {...sliderSettings}>
                
                            <div className="service-wrap" >
                                <div className="service-item">
                                    <div className="service-head">
                                            
                                       <FrontendAnimation className="el-icon-icon"  />
                              
                                    </div>
                                    <div className="service-body">
                                        <h3>As Frontend</h3>
                                        <p>UI effects, animations and dynamic user experiences.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="service-wrap" >
                                <div className="service-item">
                                    <div className="service-head">
                                       <ReactAnimation className="el-icon-icon"  />
                                    </div>
                                    <div className="service-body">
                                        <h3>As JavaScript library</h3>
                                        <p>React and Redux for state management.</p>
                                        
                                    </div>
                                </div>
                            </div>
                            <div className="service-wrap" >
                                <div className="service-item">
                                <div className="service-head">
                                        <MongoAnimation className="el-icon-icon" />
            
                                    </div>
                                    <div className="service-body">
                                        <h3>As Database</h3>
                                        <p>Mongo DB and Node JS.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="service-wrap" >
                                <div className="service-item">
                                    <div className="service-head">
                                       <WebAnimation/>
                                    </div>
                                    <div className="service-body">
                                        <h3>As Web Development</h3>
                                        <p>Responsive websites that are fast, easy to use.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="service-wrap" >
                                <div className="service-item">
                                    <div className="service-head">
                                       <RestfulAnimation />
                                    </div>
                                    <div className="service-body">
                                        <h3>As Api</h3>
                                        <p>RESTful API for interaction with RESTful web services. </p>
                                        
                                    </div>
                                </div>
                            </div>
                            <div className="service-wrap" >
                                <div className="service-item">
                                    <div className="service-head">
                                       <ResponsiveAnimation />
                                    </div>
                                    <div className="service-body">
                                        <h3>As Web Design</h3>
                                        <p>Web pages render well on a variety of devices.</p>
                                        
                                    </div>
                                </div>
                            </div>
        
                    </Slider>
                </Container>
            </div>
        </section>
    );
}

export default Service;
